import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, KeyRound } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const { t } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
    } catch {
      // Intentionally ignored — the response is always generic, never reveals
      // whether the email exists, to avoid account enumeration.
    } finally {
      setLoading(false);
      setSent(true);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-screen lg:min-h-[calc(100vh-5rem)] bg-gradient-to-br from-slate-50 to-white flex items-center justify-center px-4 py-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
          <div className="flex flex-col items-center mb-6 text-center">
            <div className="h-12 w-12 rounded-xl bg-[#028CF8]/10 flex items-center justify-center mb-3">
              <KeyRound className="h-6 w-6 text-[#028CF8]" />
            </div>
            <h1 className="font-bold text-lg text-slate-900">{t("auth.forgotPassword")}</h1>
            {!sent && <p className="text-sm text-slate-500 mt-1">{t("auth.forgotPasswordSubtitle")}</p>}
          </div>

          {sent ? (
            <p data-testid="forgot-password-sent-message" className="text-sm text-slate-700 text-center">
              {t("auth.resetEmailSent")}
            </p>
          ) : (
            <form onSubmit={handleSubmit} data-testid="forgot-password-form" className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1.5">{t("auth.emailLabel")}</label>
                <input
                  data-testid="forgot-password-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("auth.emailPlaceholder")}
                  className="w-full h-11 rounded-lg border border-slate-200 px-4 text-base sm:text-sm focus:outline-none focus:ring-2 focus:ring-[#028CF8]/30 focus:border-[#028CF8] transition-all"
                />
              </div>
              <button
                type="submit"
                data-testid="forgot-password-submit"
                disabled={loading}
                className="w-full h-11 btn-primary justify-center rounded-xl text-sm disabled:opacity-50"
              >
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : t("auth.sendResetLink")}
              </button>
            </form>
          )}

          <div className="text-center mt-5">
            <Link to="/auth" data-testid="forgot-password-back-to-login" className="text-xs text-[#028CF8] font-medium hover:underline">
              {t("auth.backToLogin")}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
